export const buttonStyles = {
	flex: '0 0 auto',
	whiteSpace: 'nowrap',
	minWidth: 'fit-content',
};
